import { render, staticRenderFns } from "./customProducto.vue?vue&type=template&id=2f4f544f"
import script from "./customProducto.vue?vue&type=script&lang=js"
export * from "./customProducto.vue?vue&type=script&lang=js"
import style0 from "./customProducto.vue?vue&type=style&index=0&id=2f4f544f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports